export const CaseAssociatedTypeFilter = [
    {
        key: 'Select',
        value: ''
    },
    {
        key: 'Customer',
        value: 'Customer',
    },
    {
        key: 'Property',
        value: 'Property',
    },
    {
        key: 'Divided block',
        value: 'Divided block',
    },
    {
        key: 'Block',
        value: 'Block',
    },
    {
        key: 'Estate',
        value: 'Estate',
    }
]